export const licenseKey =
    'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjdhYjVmMDlkLWJkNjMtNDZiNy05NDY0LTEzZmNhZjUwNjJjNyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.AuhUBnNCAMa9hZgAOspcsmu5tYPPe+nLchGb4dL7ema/noCGYzfDUXSgRi0lBcrkBJcGVLMsdry3ED0gyD09/VerLHg6PqZ5+T2Qmpb0h4MWS/ntzbY0oqp3kLtXd3Mbnm1qmQ==';
